import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BaseRoutes } from '@nts/std';
import { environment } from 'src/environments/environment';

export const CORPORATE_PROFILE_DOMAIN_MODEL_FULL_NAME = 'Subject.CorporateProfileObjects.Models.CorporateProfile';
export const CORPORATE_PROFILE_BIRTH_DOMAIN_MODEL_FULL_NAME = 'Subject.CorporateProfileBirthObjects.Models.CorporateProfileBirth';
export const COMPANY_DOMAIN_MODEL_FULL_NAME = 'Subject.CompanyObjects.Models.Company';
export const COMPANY_MAIN_BANK_DOMAIN_MODEL_FULL_NAME = 'Subject.CompanyMainBankObjects.Models.CompanyMainBank';
export const COMPANY_BIRTH_DOMAIN_MODEL_FULL_NAME = 'Subject.CompanyBirthObjects.Models.CompanyBirth';

const title = environment ? environment.appTitle : 'Application Title';
const routes: Routes = [

  // #region rotte con autenticazione
  ...BaseRoutes.getBaseAuthentictedRoutes(
    environment,
    [
      ...BaseRoutes.getEntityRoutes(
        title,
        "lead",
        () => import('./lead/lead.module').then(m => m.LeadModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        "customer",
        () => import('./customer/customer.module').then(m => m.CustomerModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        "supplier",
        () => import('./supplier/supplier.module').then(m => m.SupplierModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        "company",
        () => import('./company/company.module').then(m => m.CompanyModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        "subjectsettings",
        () => import('./subject-settings/subject-settings.module').then(m => m.SubjectSettingsModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        "customerstaff",
        () => import('./customer-staff/customer-staff.module').then(m => m.CustomerStaffModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        "supplierstaff",
        () => import('./supplier-staff/supplier-staff.module').then(m => m.SupplierStaffModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        "leadstaff",
        () => import('./lead-staff/lead-staff.module').then(m => m.LeadStaffModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        "companystaff",
        () => import('./company-staff/company-staff.module').then(m => m.CompanyStaffModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        "customerdestination",
        () => import('./customer-destination/customer-destination.module').then(m => m.CustomerDestinationModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        "supplierdestination",
        () => import('./supplier-destination/supplier-destination.module').then(m => m.SupplierDestinationModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        "leaddestination",
        () => import('./lead-destination/lead-destination.module').then(m => m.LeadDestinationModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        "agent",
        () => import('./agent/agent.module').then(m => m.AgentModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        "riskscoredashboardlongop",
        () => import('./risk-score-dashboard-long-op/risk-score-dashboard-long-op.module').then(m => m.RiskScoreDashboardLongOpModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        "generalsubjectriskscore",
        () => import('./general-subject-risk-score/general-subject-risk-score.module').then(m => m.GeneralSubjectRiskScoreModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        "anticipayservicesdatalongop",
        () => import('./anticipay-services-data-long-op/anticipay-services-data-long-op.module').then(m => m.AnticipayServicesDataLongOpModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        "staffrole",
        () => import('./staff-role/staff-role.module').then(m => m.StaffRoleModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        "corporateprofile",
        () => import('./corporate-profile/corporate-profile.module').then(m => m.CorporateProfileModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        "corporateprofilebirth",
        () => import('./corporate-profile-birth/corporate-profile-birth.module').then(m => m.CorporateProfileBirthModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        "companymainbank",
        () => import('./company-main-bank/company-main-bank.module').then(m => m.CompanyMainBankModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        "generalsubjectbank",
        () => import('./general-subject-bank/general-subject-bank.module').then(m => m.GeneralSubjectBankModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        "generalsubjectbirth",
        () => import('./general-subject-birth/general-subject-birth.module').then(m => m.GeneralSubjectBirthModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        "companybirth",
        () => import('./company-birth/company-birth.module').then(m => m.CompanyBirthModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        "companybranch",
        () => import('./company-branch/company-branch.module').then(m => m.CompanyBranchModule)
      ),
      ...BaseRoutes.getDefaultRoutes(
        title,
        environment,
        true
      )
    ]
  ),
  // #endregion rotte con autenticazione

  // rotte base per la gestione degli errori
  ...BaseRoutes.getBaseErrorsRoute()
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
